import { Select } from 'antd'
import { Option } from 'antd/lib/mentions'
import { Sort_jobCard, Sort_jobCard_completed } from 'features/auth/userSlice'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

const AscDesc = ({sort}) => {
    const dispatch=useDispatch()
    
    // Get current sort value from Redux
    const currentSort = useSelector((state) => 
        sort === "completed" ? state.user.sort_job_completed : state.user.sort_job
    )
    
    const handleSelect=(value)=>{
        if(value === "-1" || value === "id"){
            // Reset to default (ascending job card number)
            if(sort==="completed"){
                dispatch(Sort_jobCard_completed("id"))
            }else{
                dispatch(Sort_jobCard("id"))
            }
        } else {
            // Pass column name as sort value (e.g., "-date", "-deliver_date", "-id")
            if(sort==="completed"){
                dispatch(Sort_jobCard_completed(value))
            }else{
                dispatch(Sort_jobCard(value))
            }
        }
    }
    
    // Determine the display value
    const getDisplayValue = () => {
        if(currentSort === -1 || currentSort === "-1" || !currentSort || currentSort === "id"){
            return "id"
        }
        return String(currentSort)
    }

    return (
        <Select 
            onSelect={handleSelect} 
            style={{width:"300px",margin:"0px 10px"}} 
            placeholder="Select Sort" 
            value={getDisplayValue()}
        >
            <Option value="id">Ascending - Job Card No.</Option>
            <Option value="-id">Descending - Job Card No.</Option>
            <Option value="-date">Descending - Date</Option>
            <Option value="-deliver_date">Descending - Deliver Date</Option>
        </Select>
    )
}

export default AscDesc
